var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles},[_c('span',{staticClass:"risk-pill__rating"},[_vm._v(_vm._s(_vm.zeroBasedRating()))]),_vm._v(" "),_c('span',{staticClass:"risk-pill__description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }